import React from "react";
import ModalBasic from "@/components/ModalBasic.jsx";
import CustomerDetail from "@/pages/crm/people/CustomerDetail.jsx";

const CustomerDetailModal = ({ 
  modalOpen, 
  setModalOpen, 
  customerEmail,
  title = "Customer Profile"
}) => {
  return (
    <ModalBasic
      width="8xl"
      classNames="max-h-[90vh]"
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      title={title}
    >
      <CustomerDetail 
        modalMode={true}
        customerEmail={customerEmail}
        onClose={() => setModalOpen(false)}
      />
    </ModalBasic>
  );
};

export default CustomerDetailModal;
